import { useState, Fragment, useEffect } from "react";
import { Card, CardBody, CardHeader, CardTitle, Col, FormGroup, Label, Row, InputGroup, Input, InputGroupAddon, Spinner, Button} from "reactstrap";
import * as Yup from "yup";
import SelectUf from "../../../../../components/Select/SelectUf/index";
import SelectMunicipioSouLegal from "../../../../../components/Select/SelectMunicipioSouLegal/index";
import { options as optionsUf } from "../../../../../components/Select/SelectUf/options";
import { options as optionsMunicipio } from "../../../../../components/Select/SelectMunicipioSouLegal/options";
import { cpfCnpjMask, phoneMask } from "../../../../../utils/mask";

const Step3 = ({ values, setValues, setCurrentStep }) => {
  const [isSubmittingCep, setIsSubmittingCep] = useState(false);
  const [ufImovelCompradorValue, setUfImovelCompradorValue] = useState();
  const [municipioImovelCompradorValue, setMunicipioImovelCompradorValue] = useState();

  const handleSetUfImovelCompradorValue = (value) => {
    const _ufImovelCompradorValue = optionsUf.find(uf => uf.value === value);
    setUfImovelCompradorValue(_ufImovelCompradorValue);
  }

  const handleSetMunicipioImovelCompradorValue = (value) => {
    const _municipioImovelCompradorValue = optionsMunicipio.find(municipio => municipio.value === value);
    setMunicipioImovelCompradorValue(_municipioImovelCompradorValue);
  }

  const handlePrevious = () => {
    setValues(formData);
    setCurrentStep(1);
  }

  const toLowerCase = (value) => {
    return value.toLowerCase();
  }

  const getEndereco = async () => {
    setIsSubmittingCep(true);
    const cep = formData.cep_imovel_comprador;
    await fetch(`https://viacep.com.br/ws/${cep}/json`, { method: 'GET'})
      .then(response => {
        if (!response.ok) {
          throw new Error('Erro na requisição');
        }
        return response.json();
      })
      .then(data => {
        setFormData({
          ...formData,
          uf_imovel_comprador: data.uf,
          logradouro_comprador: data.logradouro,
          bairro_imovel_comprador: data.bairro
        });

        handleSetUfImovelCompradorValue(data.uf);
      }).catch(error => {
        console.log(error);
      });
      setIsSubmittingCep(false);
  }

  const validationSchema = Yup.object().shape({
    numero_identificacao_comprador: Yup.string().required("Campo CPF/CNPJ é obrigatório").cpfCnpj("CPF/CNPJ inválido"),
    nome_comprador: Yup.string().required("Campo Nome do Comprador é obrigatório"),
    email_comprador: Yup.string().required("Campo Email do Comprador é obrigatório").email("Campo E-mail do Comprador é inválido"),
    telefone_comprador: Yup.string().notRequired().telefone("Telefone inválido"),
    cep_imovel_comprador: Yup.string().required("Campo Cep do Comprador é obrigatório"),
    uf_imovel_comprador: Yup.string().required('A UF do Comprador é obrigatória').uppercase().oneOf(['AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'], "Campo UF do Comprador inválido"),
    municipio_imovel_comprador: Yup.string().required("Campo Município do Comprador é obrigatório"),
    logradouro_comprador: Yup.string().required("Campo Logradouro do Comprador é obrigatório"),
    numero_imovel_comprador: Yup.string().required("Campo Número do Comprador é obrigatório"),
    bairro_imovel_comprador: Yup.string().required("Campo Bairro do Comprador é obrigatório"),
  });

  const validate = async () => {
    try {
      await validationSchema.validate(formData, { abortEarly: false });

      setErrors({});
      setValues(formData);
      setCurrentStep(3);
      return true;
    } catch (error) {
      const validationErrors = {};
      error.inner.forEach((err) => {
        validationErrors[err.path] = err.message;
      });

      setErrors(validationErrors);

      return false;
    }
  };

  useEffect(() => {
    if (values.uf_imovel_comprador) {
      handleSetUfImovelCompradorValue(values.uf_imovel_comprador);
    }

    if (values.municipio_imovel_comprador) {
      handleSetMunicipioImovelCompradorValue(values.municipio_imovel_comprador);
    }

    setFormData({
      numero_identificacao_comprador: values.numero_identificacao_comprador,
      nome_comprador: values.nome_comprador,
      email_comprador: values.email_comprador,
      telefone_comprador: values.telefone_comprador,
      cep_imovel_comprador: values.cep_imovel_comprador,
      uf_imovel_comprador: values.uf_imovel_comprador,
      municipio_imovel_comprador: values.municipio_imovel_comprador,
      logradouro_comprador: values.logradouro_comprador,
      numero_imovel_comprador: values.numero_imovel_comprador,
      complemento_imovel_comprador: values.complemento_imovel_comprador,
      bairro_imovel_comprador: values.bairro_imovel_comprador
    });
  }, [values])

  const [formData, setFormData] = useState({
    numero_identificacao_comprador: '',
    nome_comprador: '',
    email_comprador: '',
    telefone_comprador: '',
    cep_imovel_comprador: '',
    uf_imovel_comprador: '',
    municipio_imovel_comprador: '',
    logradouro_comprador: '',
    numero_imovel_comprador: '',
    complemento_imovel_comprador: '',
    bairro_imovel_comprador: ''
  });

  const [errors, setErrors] = useState({
    numero_identificacao_comprador: '',
    nome_comprador: '',
    email_comprador: '',
    telefone_comprador: '',
    cep_imovel_comprador: '',
    uf_imovel_comprador: '',
    municipio_imovel_comprador: '',
    logradouro_comprador: '',
    numero_imovel_comprador: '',
    complemento_imovel_comprador: '',
    bairro_imovel_comprador: ''
  });

  const setFieldValue = (name, value) => {
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  return (
    <Fragment>
      <Card className="border-custom">
        <CardHeader className="card-custom">
          <CardTitle className="card-text-custom">Dados do Comprador</CardTitle>
        </CardHeader>
        <CardBody>
          <Row>
            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="numero_identificacao_comprador"><span className="text-danger">***</span> CPF ou CNPJ</Label>
                <Input
                  type="text"
                  name="numero_identificacao_comprador"
                  id="numero_identificacao_comprador"
                  placeholder="Digite o CPF ou CNPJ"
                  value={formData.numero_identificacao_comprador}
                  className={"form-control" + (errors.numero_identificacao_comprador ? " is-invalid" : "")}
                  onChange={(e) => setFieldValue('numero_identificacao_comprador', cpfCnpjMask(e.target.value))}
                  maxLength="18"
                />
                 <div className="invalid-feedback">{errors.numero_identificacao_comprador}</div>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="nome_comprador"><span className="text-danger">***</span> Nome</Label>
                <Input
                  type="text"
                  name="nome_comprador"
                  id="nome_comprador"
                  placeholder="Digite o Nome"
                  onChange={(e) => setFieldValue('nome_comprador', e.target.value)}
                  value={formData.nome_comprador}
                  className={"form-control" + (errors.nome_comprador ? " is-invalid" : "")}
                />
                <div className="invalid-feedback">{errors.nome_comprador}</div>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="email_comprador"><span className="text-danger">***</span> E-mail</Label>
                <Input
                  type="text"
                  name="email_comprador"
                  id="email_comprador"
                  placeholder="Digite o E-mail"
                  onChange={(e) => setFieldValue('email_comprador', e.target.value)}
                  onKeyUp={(e) => setFieldValue('email_comprador', toLowerCase(e.target.value))}
                  value={formData.email_comprador}
                  className={"form-control" + (errors.email_comprador ? " is-invalid" : "")}
                />
                <div className="invalid-feedback">{errors.email_comprador}</div>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="telefone_comprador">Telefone</Label>
                <Input
                  type="text"
                  name="telefone_comprador"
                  id="telefone_comprador"
                  placeholder="Digite o Telefone"
                  className={"form-control" + (errors.telefone_comprador ? " is-invalid" : "")}
                  onChange={(e) => setFieldValue('telefone_comprador', phoneMask(e.target.value))}
                  value={formData.telefone_comprador}
                  maxLength={15}
                />
                <div className="invalid-feedback">{errors.telefone_comprador}</div>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <Label htmlFor="cep_imovel_comprador"><span className="text-danger">***</span> Cep</Label>
              <InputGroup>
                <Input
                  type="text"
                  name="cep_imovel_comprador"
                  id="cep_imovel_comprador"
                  placeholder="Digite o Cep"
                  onChange={(e) => setFieldValue('cep_imovel_comprador', e.target.value)}
                  value={formData.cep_imovel_comprador}
                  className={"form-control" + (errors.cep_imovel_comprador ? " is-invalid" : "")}
                />
                <InputGroupAddon addonType="append">
                <Button type="button" color="primary" onClick={() => getEndereco()} disabled={!formData.cep_imovel_comprador || isSubmittingCep}>
                  {isSubmittingCep ? <Spinner color="light" size="sm" className="mr-1" /> : <i className="fa-solid fa-magnifying-glass"></i>}
                </Button>
                </InputGroupAddon>
                <div className="invalid-feedback">{errors.cep_imovel_comprador}</div>
              </InputGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="uf_imovel_comprador"><span className="text-danger">***</span> UF</Label>
                <SelectUf
                  name="uf_imovel_comprador"
                  id="uf_imovel_comprador"
                  placeholder={isSubmittingCep ? "..." : "Selecione a UF"}
                  className={errors.uf_imovel_comprador ? "is-invalid invalid-multi-select" : ""}
                  onChange={(data) => { setFieldValue("uf_imovel_comprador", data ? data.value : ""); handleSetUfImovelCompradorValue(data.value) }}
                  isSearchable={true}
                  isClearable={true}
                  value={ufImovelCompradorValue}
                  disabled={isSubmittingCep}
                />
                <div className="invalid-feedback">{errors.uf_imovel_comprador}</div>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="municipio_imovel_comprador"><span className="text-danger">***</span> Município</Label>
                <SelectMunicipioSouLegal
                  name="municipio_imovel_comprador"
                  placeholder="Selecione um Município"
                  className={errors.municipio_imovel_comprador ? "is-invalid invalid-multi-select" : ""}
                  onChange={(data) => { setFieldValue("municipio_imovel_comprador", data ? data.value : ""); handleSetMunicipioImovelCompradorValue(data.value) }}
                  isSearchable={true}
                  isClearable={true}
                  value={municipioImovelCompradorValue}
                />
                <div className="invalid-feedback">{errors.municipio_imovel_comprador}</div>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="bairro_imovel_comprador"><span className="text-danger">***</span> Bairro</Label>
                <Input
                  type="text"
                  name="bairro_imovel_comprador"
                  id="bairro_imovel_comprador"
                  placeholder="Digite o Bairro"
                  value={isSubmittingCep ? "..." : formData.bairro_imovel_comprador}
                  onChange={(e) => setFieldValue('bairro_imovel_comprador', e.target.value)}
                  className={"form-control" + (errors.bairro_imovel_comprador ? " is-invalid" : "")}
                  disabled={isSubmittingCep}
                />
                <div className="invalid-feedback">{errors.bairro_imovel_comprador}</div>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="logradouro_comprador"><span className="text-danger">***</span> Logradouro</Label>
                <Input
                  type="text"
                  name="logradouro_comprador"
                  id="logradouro_comprador"
                  placeholder="Digite o Logradouro"
                  value={isSubmittingCep ? "..." : formData.logradouro_comprador}
                  onChange={(e) => setFieldValue('logradouro_comprador', e.target.value)}
                  className={"form-control" + (errors.logradouro_comprador ? " is-invalid" : "")}
                  disabled={isSubmittingCep}
                />
                <div className="invalid-feedback">{errors.logradouro_comprador}</div>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="numero_imovel_comprador"><span className="text-danger">***</span> Número</Label>
                <Input
                  type="text"
                  name="numero_imovel_comprador"
                  id="numero_imovel_comprador"
                  placeholder="Digite o Número"
                  value={formData.numero_imovel_comprador}
                  onChange={(e) => setFieldValue('numero_imovel_comprador', e.target.value)}
                  className={"form-control" + (errors.numero_imovel_comprador ? " is-invalid" : "")}
                />
                <div className="invalid-feedback">{errors.numero_imovel_comprador}</div>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="complemento_imovel_comprador">Complemento</Label>
                <Input
                  type="text"
                  name="complemento_imovel_comprador"
                  id="complemento_imovel_comprador"
                  placeholder="Digite o Complemento"
                  onChange={(e) => setFieldValue('complemento_imovel_comprador', e.target.value)}
                  value={formData.complemento_imovel_comprador}
                  className={"form-control" + (errors.complemento_imovel_comprador ? " is-invalid" : "")}
                />
                <div className="invalid-feedback">{errors.complemento_imovel_comprador}</div>
              </FormGroup>
            </Col>

          </Row>
        </CardBody>
      </Card>
      <div className="text-center">
        <Button className="mr-1" color="primary" onClick={() => handlePrevious()}>Anterior</Button>
        <Button className="mr-1" color="primary" onClick={validate}>Próximo</Button>
      </div>
    </Fragment>
  );
};

export default Step3;